import UserAuth from "components/AuthGaurd/UserAuth";
import Footer from "components/footer/Footer";
import Header from "components/header/Header";
import UserEditProfile from "components/user/UserEditProfile";
import UserHeroSection from "components/user/UserHeroSection";
import React from "react";

const EditProfile = () => {
  return (
    <UserAuth>
      <header>
        <Header />
      </header>
      <UserHeroSection title="My Profile">
        <UserEditProfile />
      </UserHeroSection>

      <footer className="tw-hidden lg:tw-block">
        <Footer />
      </footer>
    </UserAuth>
  );
};

export default EditProfile;
